module.exports = __webpack_public_path__ + "static/media/TJ-retention.7ae873a4.jpg";